<template>
    <div>
        <input
            :class="{'font-italic': disabled, 'money-bold': bold}"
            v-if="!isReadOnly"
            type="text"
            v-model="displayValue"
            :placeholder="placeholder"
            @blur="isInputActive = false"
            @focus="isInputActive = true" />
        <input
            :class="{'font-italic': disabled, 'money-bold': bold}"
            v-else
            type="text"
            readonly
            v-model="displayValue" />
    </div>
</template>
<script>
// import Dinero from 'dinero.js'
export default {
  data () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Dinero.vue